import type { FC } from 'react';

import { useUpdateAccountAnalyticsSettings } from '@zen/Accounts/AccountForms/hooks/useUpdateAccountAnalyticsSettings';
import { Switch } from '@zen/DesignSystem';
import useAccount from '@zen/utils/hooks/useAccount';

import type { AccountAnalyticsSettings } from '../types';

interface Props {
  settings: Omit<AccountAnalyticsSettings, 'analyticsUserId' & 'accountId'>;
}

const AnalyticsSettingToggle: FC<Props> = ({ settings }) => {
  const { accountUuid: accountId } = useAccount();
  const { handleUpdateAccountAnalyticsSettings, loading } = useUpdateAccountAnalyticsSettings();
  const { analyticsEnabled, analyticsSharedUserEnabled } = settings;

  const handleChange = async (isChecked: boolean): Promise<void> => {
    await handleUpdateAccountAnalyticsSettings(accountId, {
      analyticsEnabled: isChecked,
      analyticsSharedUserEnabled: !isChecked ? false : analyticsSharedUserEnabled
    });
  };

  return (
    <div data-testid="analytics-setting-toggle">
      <Switch
        label="Analytics"
        labelHint="Enable analytics for this account."
        isChecked={analyticsEnabled}
        onChange={handleChange}
        isDisabled={loading}
      />
    </div>
  );
};

export default AnalyticsSettingToggle;
